export default function() {
  window.carrotquest.open()
}
